import { Platform, useWindowDimensions } from 'react-native';
export default function useMobile() {
  let mobileBreakpoint = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 575;
  const {
    width
  } = useWindowDimensions();
  if (Platform.OS === 'web') return width <= mobileBreakpoint;
  return ['android', 'ios'].includes(Platform.OS);
}
//# sourceMappingURL=use-mobile.js.map